import JackpotMeterComponent from "./jackpot/jackpot-meter-component";
import RainbowStacksCelebrateWinComponent from "./celebrate-win/celebrate-win-component";
import RulesButtonComponent from "./rules/rules-button-component";
import BonusBuyButtonComponent from "./bonus-buy/bonus-buy-button-component";
import ScatterEmitterComponent from "./celebrate-win/scatter-emitter-component";
import Components from "slotworks/components/components";
import RSReelSpinner from "./matrix/reel-spinner";
import RSPromptComponent from "./prompt/prompt-component";

class RainbowStacksComponents {

    public celebrateWin: RainbowStacksCelebrateWinComponent;
    public jackpotMeters: JackpotMeterComponent;
    public rulesButton: RulesButtonComponent;
    public bonusBuyButton: BonusBuyButtonComponent;
    public scatterEmitter: ScatterEmitterComponent;
    public prompt: RSPromptComponent;

    public init() {
        this.celebrateWin = new RainbowStacksCelebrateWinComponent();
        this.jackpotMeters = new JackpotMeterComponent();
        this.rulesButton = new RulesButtonComponent();
        this.bonusBuyButton = new BonusBuyButtonComponent();
        this.scatterEmitter = new ScatterEmitterComponent();
        this.initMatrix();
        this.prompt = new RSPromptComponent();
    }

    private initMatrix() {
        const config = Components.config.matrix;

        if (config) {
            if (config.transition.options.spinStages) {
                RSReelSpinner.spinStages = config.transition.options.spinStages;
            }
            if (config.transition.options.skipStages) {
                RSReelSpinner.skipStages = config.transition.options.skipStages;
            }
            if (config.transition.options.anticipationStages) {
                RSReelSpinner.anticipationStages = config.transition.options.anticipationStages;
            }
        }
    }

}

const rainbowStacksComponents = new RainbowStacksComponents();
export default rainbowStacksComponents;


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/components.ts